<template>
    <div>
      <div class="m_context plr mb30">
		<el-row>
			<el-col :span="24">
			 <el-form ref="addForm" id="addForm" :model="form" label-width="12.5%">
			 	<el-form-item :label="$t('lin_global.label_areaid')">
                    <!--<el-select @change = "changeEvent" filterable clearable v-model="form.mechanismId" :placeholder="$t('lin_global.place_areaid')" class="w_33">-->
                       <!--<el-option v-for="item in areaList" :label="item.mechanismname" :value="item.mechanismid">-->
                       <!--</el-option>-->
                    <!--</el-select>-->

                    <MechanismSelector :data="mechanismData" :mselect="true" :classs="'w_33'"></MechanismSelector>
                </el-form-item>
                <el-form-item :label="$t('lin_global.ter_num')">
                	<span style="padding-left: 10px;">  {{form.terNums}}  </span>{{$t('terminal.appLog.tower')}}
                </el-form-item>
                <el-form-item :label="$t('lin_global.version')">
                  <el-input v-model="form.version"></el-input>
                </el-form-item>
                <el-form-item :label="$t('lin_global.remark')">
					<el-input type="textarea" v-model="form.memo" style="width:100%"></el-input>
				</el-form-item>
				<el-form-item>
		          <el-button @click="onCancel">{{$t('lin_btn.cancel')}}</el-button>
		          <el-button type="primary" :loading="isSubmit" @click="submit">{{$t('lin_btn.submit')}}</el-button>
		        </el-form-item>
			 </el-form>
			</el-col>
		</el-row>
      </div>

        <div class='gPageBorder'>
			<el-table :data="tableData" id="tableData" border>
		      <el-table-column prop="createTime" :label="$t('lin_global.time')" :show-overflow-tooltip="true" width="200"></el-table-column>
		      <el-table-column prop="mechanismName" :label="$t('lin_global.label_areaid')" :show-overflow-tooltip="true"></el-table-column>

		      <el-table-column prop="version" :label="$t('lin_global.version')" :show-overflow-tooltip="true" width="150"></el-table-column>
		       <el-table-column prop="memo" :label="$t('lin_global.remark')" :show-overflow-tooltip="true"></el-table-column>

		      <!-- <el-table-column prop="create_time" label="设备数量"></el-table-column> -->

		    </el-table>
		    <div v-if="totalRecords > 0" class="gPgDiv" id="">
		      <el-pagination class='gPg' @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10,50,100]"
		        :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalRecords">
		      </el-pagination>
		    </div>
	    </div>
	</div>
</template>

<script>
import axios from 'axios'
import { baseurl } from '../../api/url'
import MechanismSelector from '@/components/global/mechanism_selector.vue'
export default{
  components: {
    MechanismSelector
  },
	data(){
    var that = this
		return{
      mechanismData: {
        placeholder: that.$t('lin_global.place_areaid'),
        callback (value) {
          that.form.mechanismId = value
          that.changeEvent()
        }
      },
      isSubmit: false,
			form:{
				mechanismId:'',
				terNums:0,
				version:'',
				memo:''

			},
			totalRecords: 0,
			currentPage: 1,
		    pageSize: 10,
			areaList:[],
			tableData:[]
		}
	},
	created(){
//		this.getAd();
		this.getData(1);
	},
	methods:{
		handleSizeChange: function (val) {
	        this.pageSize = val
	        this.getData(this.currentPage)
	        //console.log(`每页 ${val} 条`)
	    },
	    handleCurrentChange: function (val) {
	        this.currentPage = val
	        this.getData(this.currentPage)
	        //console.log('当前页: ${val}')
  		},
		getData:function(page){
			var params = {page:page,rows:this.pageSize};
			axios.post(`${baseurl}/terminalBackup/list.do`,params).then(res=>{
				this.tableData = res.data.data;
				this.totalRecords = res.data.total;
			})
		},
		submit:function(){
			var params = this.form;
      this.isSubmit = true;
			//console.log("打印传入参数");
			//console.log(params)
			axios.post(`${baseurl}/terminalBackup/backup.do`,params).then(res=>{
				//console.log("打印返回数据");
				//console.log(res.data)
	            if(res.data.status == 200){
	            	this.$message.success(res.data.message);
	            	this.getData(1);
                this.isSubmit = false;
	            }else{
                this.isSubmit = false;
	            	this.$message.error(res.data.message)
	            }
	        })
		},
		changeEvent:function(){
			this.getNum()
		},
		getNum:function(){
			var params={mechanismId:this.form.mechanismId}
			console.log(params)
			axios.post(`${baseurl}/terminal/terNums.do`,params).then(res=>{
		    		//console.log(res.data);

		    		this.form.terNums = res.data.data.nums;
		    	})
		},
//		getAd:function(){
//		    	var params = {page:1,rows:10000};
//		    	axios.post(`${baseurl}/mechanism/list.do`,params).then(res=>{
//		    		//console.log(res.data);
//		    		this.areaList = res.data.data;
//		    	})
//		},
		onCancel:function(){
			this.$router.go(-1);
		}
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// backups.vue?dfb5ca62